import { motion } from "framer-motion";
import { Icon3D } from "@/components/landing/Icon3D";
import { fadeUp, cardReveal } from "@/lib/animations";
import { Section, Overline, H2 } from "./JobPrimitives";
import { responsibilities, profileTraits } from "./jobData";

export const JobResponsibilities = () => (
  <Section
    id="responsabilidades"
    className="py-16 md:py-24 bg-[#F6F8FB]"
    testid="section-responsabilidades"
  >
    <motion.div {...fadeUp} className="max-w-3xl">
      <Overline>Responsabilidades</Overline>
      <H2 highlight="irá fazer">O que você</H2>
    </motion.div>

    <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {responsibilities.map((r, idx) => (
        <motion.div
          key={r.text}
          {...cardReveal(idx * 0.04)}
          data-testid={`resp-${idx}`}
          className="group flex items-start gap-4 bg-white rounded-2xl border border-[#E5EAF2] p-6 hover:shadow-[0_18px_40px_rgba(53,50,179,0.08)] hover:border-[#3787F5]/30 transition-all duration-300"
        >
          <Icon3D
            icon={r.icon}
            variant={r.variant}
            size="md"
            className="shrink-0 group-hover:scale-110 group-hover:-rotate-3"
          />
          <p className="text-[15px] text-[#1F2937] leading-relaxed pt-1">
            {r.text}
          </p>
        </motion.div>
      ))}
    </div>
  </Section>
);

export const JobProfile = () => (
  <Section id="perfil" className="py-16 md:py-24" testid="section-perfil">
    <motion.div {...fadeUp} className="max-w-3xl">
      <Overline>Perfil que buscamos</Overline>
      <H2 highlight="analítico e atenção aos detalhes">
        Essa oportunidade é para você que tem perfil
      </H2>
      <p className="mt-6 text-lg text-[#64748B] leading-relaxed">
        Buscamos profissionais que saibam ouvir, investigar informações com
        responsabilidade, escrever com clareza e tomar decisões técnicas com
        base em dados, registros e critérios assistenciais.
      </p>
    </motion.div>

    <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-5">
      {profileTraits.map((t, idx) => (
        <motion.div
          key={t.title}
          {...cardReveal(idx * 0.04)}
          data-testid={`trait-${idx}`}
          className="group bg-white rounded-2xl border border-[#E5EAF2] p-6 text-center hover:shadow-[0_18px_40px_rgba(53,50,179,0.08)] hover:border-[#3787F5]/30 hover:-translate-y-1 transition-all duration-300"
        >
          <div className="flex justify-center mb-4">
            <Icon3D
              icon={t.icon}
              variant={t.variant}
              size="md"
              className="group-hover:scale-110 group-hover:-rotate-3"
            />
          </div>
          <h3 className="text-[15px] font-bold text-[#1F2937] leading-snug">
            {t.title}
          </h3>
        </motion.div>
      ))}
    </div>
  </Section>
);
